import { safeLocalStorageSetJson } from "../lib/storageQuotaRecovery";
import { DB } from "../lib/deviceStorage";
import React, { useState } from "react";
import { Btn, Badge, Field, Input, Modal, Toast, useToast } from "../components/ui";
import { fmtDate } from "../lib/formatters";
import { isCompactViewport, T} from "../lib/globals";
import { UI_FONT_SCALE_OPTIONS, SHORTCUT_MODULE_CHOICES, ShortcutMonoIcon, normalizeUiPreferences } from "../lib/theme";
import { makeUpdateMeta } from "../lib/meta";
import { getAccounts, saveAccounts, ensureDefaultAdminAccount, normalizeAuthAccount } from "../lib/authUtils";
import { pushGlobal } from "../sync/collectionApi";

export function createMeuPerfilModule(deps) {
  const {
    useFarmCollection,
    useSyncOnSave,
    canViewModule,
    getShortcutChoiceMeta,
  } = deps;

  function MeuPerfilModule({ session, onSessionUpdate }) {
  const [employees, setEmployees] = useFarmCollection("employees", []);
  // eslint-disable-next-line no-unused-vars
  const [pwForm,  setPwForm]  = useState(null);
  const [form,    setForm]    = useState(null);

  const [toast,   show]       = useToast();
  const syncOnSave = useSyncOnSave();
  const [savingUiPrefs, setSavingUiPrefs] = useState(false);
  const uiPreferences = normalizeUiPreferences(session?.uiPreferences);



  const myRecord = employees.find(e =>
    e.username === session?.username ||
    e.name?.toLowerCase() === session?.name?.toLowerCase()
  );


  async function persistUiPreferences(nextPrefs) {
    if (!session?.id && !session?.username) {
      show("Conta do usuário não encontrada.", "error");
      return;
    }
    const normalizedPrefs = normalizeUiPreferences(nextPrefs);
    setSavingUiPrefs(true);
    try {
      const accounts = await getAccounts();
      const updated = accounts.map(acc => {
        const sameId = session?.id && String(acc?.id || "") === String(session.id);
        const sameUser = session?.username && String(acc?.username || "").trim().toLowerCase() === String(session.username || "").trim().toLowerCase();
        if (!sameId && !sameUser) return acc;
        return normalizeAuthAccount({
          ...acc,
          uiPreferences: normalizedPrefs,
          ...makeUpdateMeta(session?.name || acc?.name || "sistema"),
        }, session?.name || acc?.name || "sistema");
      });
      const ensuredUpdated = ensureDefaultAdminAccount(updated, session?.name || "system");
      await saveAccounts(ensuredUpdated);
      try {
        const res = await pushGlobal("auth:accounts", ensuredUpdated, session?.name || "system");
        if (res?.version) await DB.set("auth:accounts:_ver", res.version);
      } catch(_) {}
      const nextSession = { ...session, uiPreferences: normalizedPrefs };
      try { safeLocalStorageSetJson("fz:session", nextSession); } catch(_) {}
      onSessionUpdate && onSessionUpdate(nextSession);
      window.dispatchEvent(new CustomEvent("fz:sync:updated", { detail: { key: "auth:accounts" } }));
      show("✅ Preferências atualizadas!");
    } catch(_) {
      show("Não foi possível salvar suas preferências.", "error");
    } finally {
      setSavingUiPrefs(false);
    }
  }

  function saveProfile() {
    if(!form.name?.trim()){show("Nome obrigatório.","error");return;}
    const updated = employees.map(e=>e.id===form.id?{...form,_new:undefined}:e);
    setEmployees(updated);
    show("✅ Perfil atualizado!"); setForm(null); syncOnSave("employees");
  }

  const themeButtons = [
    { id:"auto", label:"Automático", hint:"Segue o telefone" },
    { id:"light", label:"Claro", hint:"Fixo" },
    { id:"dark", label:"Escuro", hint:"Fixo" },
  ];

  if(!myRecord) return(
    <div style={{color:T.muted,textAlign:"center",padding:40,fontSize:14}}>
      Nenhum cadastro encontrado para seu usuário.<br/>
      Peça ao administrador para cadastrar você no módulo Colaboradores.
    </div>
  );

  return(
    <div><Toast toast={toast}/>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:24,marginBottom:20}}>
        <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:20}}>
          <div style={{width:64,height:64,borderRadius:"50%",background:`${T.accent}22`,border:`2px solid ${T.accent}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28}}>👤</div>
          <div>
            <div style={{fontWeight:800,color:T.text,fontSize:20}}>{myRecord.name}</div>
            <div style={{fontSize:13,color:T.accent,marginTop:2}}>{myRecord.role||"Colaborador"}</div>
            {myRecord.username&&<div style={{fontSize:12,color:T.muted,marginTop:1}}>@{myRecord.username}</div>}
          </div>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          {[
            {label:"📞 Telefone",  val:myRecord.phone},
            {label:"✉️ E-mail",    val:myRecord.email},
            {label:"🎂 Nascimento",val:myRecord.birthDate?fmtDate(myRecord.birthDate):null},
            {label:"💳 PIX",       val:myRecord.pix},
            {label:"🪪 CPF",       val:myRecord.cpf},
          ].filter(f=>f.val).map(f=>(
            <div key={f.label} style={{background:T.card2,borderRadius:8,padding:"10px 12px"}}>
              <div style={{fontSize:10,color:T.muted,fontWeight:700,letterSpacing:.8}}>{f.label}</div>
              <div style={{fontSize:13,color:T.text,fontWeight:600,marginTop:3}}>{f.val}</div>
            </div>
          ))}
        </div>

        <div style={{display:"flex",gap:10,marginTop:16,flexWrap:"wrap"}}>
          <Btn onClick={()=>setForm({...myRecord,_new:false})}>✏️ Editar dados</Btn>
        </div>
      </div>

      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:24,marginBottom:20}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,flexWrap:"wrap",marginBottom:14}}>
          <div>
            <div style={{fontWeight:800,color:T.text,fontSize:18}}>🎛️ Aparência e leitura</div>
            <div style={{fontSize:12,color:T.muted,marginTop:4}}>As alterações abaixo são salvas na sua conta e aplicadas em tempo real.</div>
          </div>
          {savingUiPrefs && <Badge color={T.accent}>Salvando…</Badge>}
        </div>

        <div style={{display:"grid",gap:18}}>
          <div>
            <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:10}}>Tamanho da letra do app</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {UI_FONT_SCALE_OPTIONS.map(scale=>{
                const active = uiPreferences.fontScale === scale;
                return (
                  <button
                    key={scale}
                    type="button"
                    onClick={()=>persistUiPreferences({ ...uiPreferences, fontScale: scale })}
                    style={{
                      padding:"10px 14px",
                      minWidth:68,
                      borderRadius:999,
                      border:`1px solid ${active ? T.accent : `${T.border}CC`}`,
                      background:active ? `${T.accent}22` : "rgba(148,163,184,.10)",
                      backdropFilter:"blur(10px)",
                      WebkitBackdropFilter:"blur(10px)",
                      color:active ? T.accent : T.text,
                      fontWeight:700,
                      cursor:"pointer",
                      transition:"all .15s ease",
                    }}
                  >
                    {scale}%
                  </button>
                );
              })}
            </div>
          </div>

          <div>
            <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:10}}>Tema do aplicativo</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {themeButtons.map(option=>{
                const active = uiPreferences.themeMode === option.id;
                return (
                  <button
                    key={option.id}
                    type="button"
                    onClick={()=>persistUiPreferences({ ...uiPreferences, themeMode: option.id })}
                    style={{
                      padding:"10px 14px",
                      minWidth:120,
                      borderRadius:14,
                      border:`1px solid ${active ? T.accent : `${T.border}CC`}`,
                      background:active ? `${T.accent}18` : "rgba(148,163,184,.10)",
                      backdropFilter:"blur(10px)",
                      WebkitBackdropFilter:"blur(10px)",
                      color:active ? T.accent : T.text,
                      cursor:"pointer",
                      transition:"all .15s ease",
                    }}
                  >
                    <div style={{fontSize:13,fontWeight:800}}>{option.label}</div>
                    <div style={{fontSize:11,color:active ? T.accent : T.muted,marginTop:2}}>{option.hint}</div>
                  </button>
                );
              })}
            </div>
          </div>

          <div>
            <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:10}}>Barra inferior de atalhos</div>
            <div style={{fontSize:11,color:T.muted,marginBottom:10}}>A casinha fica fixa. Escolha até 4 módulos para aparecerem na barra de atalhos dentro da fazenda.</div>
            <div style={{display:"grid",gridTemplateColumns:isCompactViewport()?"repeat(2,minmax(0,1fr))":"repeat(auto-fit,minmax(170px,1fr))",gap:10}}>
              {SHORTCUT_MODULE_CHOICES
                .filter(moduleId=>canViewModule(session, moduleId))
                .map(moduleId=>{
                  const meta = getShortcutChoiceMeta(moduleId);
                  const selected = uiPreferences.shortcutModules.includes(moduleId);
                  const disabled = !selected && uiPreferences.shortcutModules.length >= 4;
                  return (
                    <button
                      key={moduleId}
                      type="button"
                      disabled={disabled}
                      onClick={()=>{
                        const current = uiPreferences.shortcutModules || [];
                        const next = selected ? current.filter(id=>id!==moduleId) : [...current, moduleId].slice(0,4);
                        persistUiPreferences({ ...uiPreferences, shortcutModules: next });
                      }}
                      style={{
                        display:"flex", alignItems:"center", gap:10,
                        padding:"10px 12px", borderRadius:14,
                        border:`1px solid ${selected ? T.accent : `${T.border}CC`}`,
                        background:selected ? `${T.accent}18` : "rgba(148,163,184,.10)",
                        color:selected ? T.accent : T.text,
                        opacity:disabled ? .5 : 1,
                        cursor:disabled ? "not-allowed" : "pointer",
                      }}
                    >
                      <span style={{width:18,height:18,display:"inline-flex",alignItems:"center",justifyContent:"center"}}><ShortcutMonoIcon type={meta.iconType} size={18} color={selected ? T.accent : T.text} /></span>
                      <span style={{fontSize:12,fontWeight:700,textAlign:"left"}}>{meta.label}</span>
                    </button>
                  );
                })}
            </div>
          </div>
        </div>
      </div>

      <Modal open={!!form} onClose={()=>setForm(null)} title="Editar Meu Perfil">
        {form&&<div style={{display:"grid",gridTemplateColumns:isCompactViewport()?"1fr":"1fr 1fr",gap:14}}>
          <Field label="Nome *" col="1/-1"><Input value={form.name||""} onChange={e=>setForm(f=>({...f,name:e.target.value}))}/></Field>
          <Field label="Telefone"><Input value={form.phone||""} onChange={e=>setForm(f=>({...f,phone:e.target.value}))}/></Field>
          <Field label="E-mail"><Input type="email" value={form.email||""} onChange={e=>setForm(f=>({...f,email:e.target.value}))}/></Field>
          <Field label="Data de Nascimento"><Input type="date" value={form.birthDate||""} onChange={e=>setForm(f=>({...f,birthDate:e.target.value}))}/></Field>
          <Field label="PIX" col="1/-1"><Input value={form.pix||""} onChange={e=>setForm(f=>({...f,pix:e.target.value}))}/></Field>
          <div style={{gridColumn:"1/-1",display:"flex",gap:10,justifyContent:"flex-end"}}>
            <Btn variant="ghost" onClick={()=>setForm(null)}>Cancelar</Btn>
            <Btn onClick={saveProfile}>Salvar</Btn>
          </div>
        </div>}
      </Modal>
    </div>
  );
}


  return MeuPerfilModule;
}
